export default __webpack_public_path__ + "static/media/ch-icon.f5f115cc.png";